var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendEmailSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8V4.5A1.5 1.5 0 0012.5 3h-9A1.5 1.5 0 002 4.5v7A1.5 1.5 0 003.5 13H8",
    stroke: "#262A33",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.367 5.5l-2.66 2.66a1 1 0 01-1.414 0L4.633 5.5",
    stroke: "#262A33",
    strokeOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9l2 2m0 0l-2 2m2-2H9.5",
    stroke: "#262A33",
    strokeOpacity: 0.7,
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDhWNC41QzE0IDMuNjcxNTcgMTMuMzI4NCAzIDEyLjUgM0gzLjVDMi42NzE1NyAzIDIgMy42NzE1NyAyIDQuNVYxMS41QzIgMTIuMzI4NCAyLjY3MTU3IDEzIDMuNSAxM0g4IiBzdHJva2U9IiMyNjJBMzMiIHN0cm9rZS1vcGFjaXR5PSIwLjciLz4KPHBhdGggZD0iTTExLjM2NzEgNS41MDAwM0w4LjcwNzExIDguMTYwMDJDOC4zMTY1OCA4LjU1MDU1IDcuNjgzNDIgOC41NTA1NSA3LjI5Mjg5IDguMTYwMDJMNC42MzI5IDUuNTAwMDMiIHN0cm9rZT0iIzI2MkEzMyIgc3Ryb2tlLW9wYWNpdHk9IjAuNyIvPgo8cGF0aCBkPSJNMTIgOUwxNCAxMU0xNCAxMUwxMiAxM00xNCAxMUg5LjUiIHN0cm9rZT0iIzI2MkEzMyIgc3Ryb2tlLW9wYWNpdHk9IjAuNyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgSendEmailSmall as ReactComponent };